export enum ReportsName {
  FLOW_STATUS = 'Flow Status',
  EXTERNAL_USER_TASK = 'External User Task Usage'
}
